module.exports = __webpack_public_path__ + "static/media/avatar.dd759e9e.png";